import { render, staticRenderFns } from "./FormulOlustur.vue?vue&type=template&id=7812dfe3"
import script from "./FormulOlustur.vue?vue&type=script&lang=js"
export * from "./FormulOlustur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports